import produce from 'immer';
import { ActionType, getType } from 'typesafe-actions';
import { VmafError } from '../../api/ErrorNormalizer';
import * as actions from './actions';
import { IVideoMeta, IVideoOutput, VideoOutputStatus } from './types';

interface IVideoOutputState {
  output: IVideoOutput;
  meta: IVideoMeta;
  status: VideoOutputStatus;
  error?: VmafError;
  needRetry?: boolean;
}

const INITIAL_OUTPUT: IVideoOutput = {
  videoUrl: '',
  thumbnailUrl: '',
  downloadUrl: '',
};

const INITIAL_META: IVideoMeta = {
  resultVideoId: null,
  videoSessionId: null,
};

const initialState: IVideoOutputState = {
  meta: INITIAL_META,
  output: INITIAL_OUTPUT,
  status: VideoOutputStatus.INITIAL,
};

function reducer(state = initialState, action: ActionType<typeof actions>) {
  return produce(state, (draftState) => {
    switch (action.type) {
      case getType(actions.storeVideoMetaId):
        draftState.meta.resultVideoId = action.payload;
        break;

      case getType(actions.storeVideoMetaSessionId):
        draftState.meta.videoSessionId = action.payload;
        break;

      case getType(actions.storeVideoMetaProgressId):
        draftState.meta.progressId = action.payload;
        break;

      case getType(actions.requestVideoOutput.request):
        draftState.output = INITIAL_OUTPUT;
        draftState.meta = {
          ...INITIAL_META,
          startTime: action.payload,
        };
        draftState.status = VideoOutputStatus.VIDEO_REQUEST;
        draftState.error = null;
        draftState.needRetry = false;
        break;

      case getType(actions.requestVideoOutput.success):
        draftState.output = { ...state.output, ...action.payload };
        draftState.status = VideoOutputStatus.VIDEO_READY;
        draftState.error = null;
        break;

      case getType(actions.requestVideoOutput.failure):
        draftState.status = VideoOutputStatus.VIDEO_ERROR;
        draftState.error = action.payload;
        break;

      case getType(actions.setVideoOutputNeedRetry):
        draftState.needRetry = true;
        break;

      default:
    }
  });
}

export type { IVideoOutputState, IVideoOutput, IVideoMeta };
export default reducer;
